<template>
    <div class="row clearfix">
        <div v-if="loading" class="loading"></div>
        <div v-if="messageStatus" class="alert alert-success" role="alert">
            {{ messageStatus }}
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="">
                <div class="header">
                    <h2>Подписанные на рассылку</h2>
                </div>
                <div class="body table-responsive">
                    <table class="table table-bordered table-striped js-table dataTable order-table">
                        <thead>
                        <tr>
                            <th>E-mail</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in items">
                            <td>{{ item.email }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AdminSubscribe",
        data() {
            return {
                items: [],
                messageStatus: null,
                loading: false
            }
        },

        mounted() {
            this.messageStatus = this.message
            this.loading = true

            this.axios
                .get(this.axios.defaults.baseURL + 'admin/subscribes')
                .then(response => {
                    this.items = response.data.subscribes;
                })
                .catch(error => {
                    console.log(error);
                }).finally(() => {
                    this.loading = false
            })
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/admin/subscribe/Index.vue